import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';

@Injectable({ providedIn: 'root' })
export class ViewboxGuestHttpClient {
  constructor(private httpApi: HttpApiService) {}

  public save({ data }: any) {
    let request: Observable<any>;
    const body = { guest: data };
    if (data.authToken) {
      request = this.httpApi.patch(`/guests`, null, body);
    } else {
      request = this.httpApi.post(`/guests`, null, body);
    }
    return request.pipe(map(resp => resp.guest));
  }
}
